"use strict";

var snakeCase = require('lodash/snakeCase');

var WaxSeal = require('../../products/components/WaxSeal');

var Inventory = require('./Inventory');

function inventoryWaxSeals(arr, date) {
  var components = arr.filter(function (comp) {
    return Object.prototype.isPrototypeOf.call(WaxSeal.prototype, comp);
  });
  var inventory = {};
  components.forEach(function (_ref) {
    var wax_seal_style = _ref.wax_seal_style,
        quantity = _ref.quantity;

    if (wax_seal_style.toLowerCase() === 'none') {
      return;
    }

    var name = wax_seal_style + ' Wax Seals';

    if (inventory[name]) {
      inventory[name] += parseInt(quantity, 10);
    } else {
      inventory[name] = parseInt(quantity, 10);
    }
  });
  return Object.keys(inventory).map(function (name) {
    return new Inventory({
      name: name,
      unit: 'each',
      key: snakeCase(name),
      category: 'wax_seals',
      quantity: inventory[name],
      date: date
    });
  });
}

module.exports = inventoryWaxSeals;